import type { FeatureFlags } from '@@/types/FeatureFlags';

export default defineNuxtPlugin(() => {
  const { $axios } = useNuxtApp();
  return {
    provide: {
      featureFlags: {
        get: async (featureFlag = '', actor_id = 'auth-service') => {
          try {
            const params = {
              actor_id: '',
            };
            //TODO: fix this  work around to catch actor id being an empty string
            if (actor_id != '') {
              params.actor_id = actor_id;
            } else {
              params.actor_id = 'auth-service';
            }
            const response = await $axios.get<FeatureFlags>(`../../feature_flags/${featureFlag}`, { params });
            return response.data;
          } catch (e) {
            //TODO: add error handling
            console.error(e);
            return {} as FeatureFlags;
          }
        },
      },
    },
  };
});
